import { Component, Inject, Input, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { WindowService } from 'src/app/core/services/window.service';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

declare var window: any;


@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit {

  @ViewChild('swiperPartners', { static: true }) swiperPartners!: SwiperComponent;

  animationInProgress = false;
  partnersConfig: SwiperOptions = {
    slidesPerView: 4,
    spaceBetween: 25,
    pagination: true,
    loop: true,
    // loopedSlides: 2,
    autoplay: {
      delay: 1000
    }
  }

  constructor(@Inject(LOCALE_ID) public locale: string, private windowSrv: WindowService){

  }

  ngOnInit(): void {
    if(this.windowSrv.isBrowser)this.setSliderConfig();
  }

  setSliderConfig(){
    let windowWidth = this.windowSrv.nativeWindow.innerWidth

    if (windowWidth > 1200) {
      this.partnersConfig.slidesPerView = 4;
    } else if (windowWidth > 767) {
      this.partnersConfig.slidesPerView = 3;
    } else if (windowWidth > 479) {
      this.partnersConfig.slidesPerView = 2;
    } else {
      this.partnersConfig.slidesPerView = 1;
    }
  }


  onSwiper(swiper: SwiperComponent) {
    if(this.windowSrv.isBrowser)this.startAnimation();
  }
  onSlideChange() {
  }

  startAnimation() {
    if (this.animationInProgress) return;
    this.animationInProgress = true;
    setTimeout(() => {
      this.swiperPartners.swiperRef.slideNext(1500);
      this.animationInProgress = false;
      this.startAnimation();
    }, 4000);
  }
}
